export default {"src":"https://assets.eu.daedalus.fih.io/_next/static/media/klarna.ec89ae7c.svg","height":11,"width":20,"blurWidth":0,"blurHeight":0};